module.exports = __webpack_public_path__ + "static/img/RM1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RM1_1.png
// module id = v6RY
// module chunks = 0